import React, { useEffect } from "react";

import { HEADER_ID, FOOTER_ID } from "../constants";
import getWidthContext from "./getWidthContext";
import { isMobileScreen } from "../services";
import { ModulesI } from "../typings/routesTypes";
import { UserI } from "../typings/interfaces";

export interface AdFormLayoutMobileProps {
  categories?: [];
  dispatch?: Function;
  history?: History;
  location?: Location;
  match?: { path: string; url: string; isExact: boolean; params: {} };
  module?: ModulesI;
  staticContext?: any;
  user?: UserI | null;
  width: number;
}

export default (Com: Function) => {
  const AdFormLayoutMobile = (props: AdFormLayoutMobileProps) => {
    useEffect(() => {
      handleShowHideElements(props);

      return () => {
        setElementVisible(HEADER_ID, "block");
        setElementVisible(FOOTER_ID, "block");
      };
    }, [props.width]);

    const handleShowHideElements = (props: AdFormLayoutMobileProps) => {
      const { width } = props;

      if (isMobileScreen(width)) {
        setElementVisible(HEADER_ID, "none");
        setElementVisible(FOOTER_ID, "none");
      } else {
        setElementVisible(HEADER_ID, "block");
        setElementVisible(FOOTER_ID, "block");
      }
    };

    const setElementVisible = (id, display) => {
      const el = document.getElementById(id);
      if (el) {
        el.style.display = display;
      }
    };

    return <Com {...props} />;
  };

  return getWidthContext(AdFormLayoutMobile);
};



// WEBPACK FOOTER //
// ./src/HOCs/handleAdFormLayoutMobile.tsx